import * as React from "react";
import { ToggleButtonTwoOptions } from "../../../react-core/Html/ToggleButtonTwoOptions";
import { JsonDateParser } from "../../../react-core/Utils/JsonDateParser";
import { InstrumentsClient } from "../../../Wrap/Api/Instruments/Instruments";
import { AccountModelViewClient } from "../../../Wrap/Api/Transaction/AccountModelView";
import { AccountAdviceType } from "../../../Wrap/Constants/Enums/Apply/AccountAdviceType";
import { AssetClassType } from "../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { ModelPortfolioTabType } from "../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { ProductType } from "../../../Wrap/Constants/Enums/Domain/ProductType";
import { SubAccountType } from "../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { Money } from "../../../Wrap/Core/DataTypes/Money";
import { ViewType } from "../../../Wrap/Mapping/PortfolioAnalysis/Investment/Enum/ViewType";
import { Instrument } from "../../../Wrap/Models/Domains/Investment/Instrument";
import { InstrumentSearchQuery } from "../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { AccountModelView } from "../../../Wrap/Models/Domains/Transactions/Investments/AccountModelView";
import { AssetClassInstrumentWeighting } from "../../../Wrap/Models/Models/PortfolioAnalysis/Investment/AssetClassInstrumentWeighting";
import { Investment } from "../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { InvestmentGroup } from "../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentGroup";
import { ProductInvestment } from "../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ProductInvestment";
import { InvestmentsAction } from "../../Dashboard/Components/Clients/PortfolioDashboard/Components/Investment/Action/InvestmentAction";
import { IProcessComponentProps, ProcessComponent } from "../Process/Process/ProcessComponent";
import { InvestmentSelectionAction } from "./Action/InvestmentSelectionAction";
import { AllocationTable } from "./Components/AllocationTable";
import { DecisionMaker } from "./Components/DecisionMaker";
import { DistributionOption } from "./Components/DistributionOption";
import { ManageIncome } from "./Components/ManageIncome";
import { Reuse } from "./Components/Reuse";
import { ReuseInvesment } from "./Components/ReuseInvesment";
import { SearchTabs } from "./Components/Shared/SearchTabs";
import { initInstrumentSelection, initWeighting } from "./Components/Shared/Utils";
import {
    distributionOptionsShowCondition,
    investmentType,
    manageIncomeShowCondition,
    ProcessType,
    reuseShowCondition,
    reuseType,
    useSameInvestmentAsPerProductShowCondition,
} from "./Resource/Content";
import { AllocationTableItem } from "./Store/SelectedInvesmentStoreStatic";
import { SelectedInvestmentStore } from "./Store/Variable";
import { reOrderISTInstruments } from "./Components/Shared/AllocationTableHelper";
import { ActionType } from "../../../react-core/Flux/ActionType";
import { RestrictionStore } from "../../Dashboard/Components/Clients/Common/Restrictions/Variable";
import { Alert } from "../Components/Alert";
import { AlertType } from "../Entities/Constants/AlertConstants";
import { PropositionInvestmentConfig } from "../../../Wrap/Models/Domains/Account/PropositionInvestmentConfig";
import { ServiceProposition } from "../../../Wrap/Constants/Enums/ServiceProposition";
import { User } from "../../../Wrap/Models/Models/User/User";
import { UserStore } from "../../Dashboard/Stroes/Variable";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../Common/UserMessages";
import { CompanyWizardAction } from "../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { ContributionAndWithdrawalBase } from "../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/ContributionAndWithdrawalBase";
import { PensionContribution } from "../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import { InstrumentSelections } from "../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelections";
import { OrderType } from "../../../Wrap/Constants/Enums/Domain/OrderType";
import { OffPlatformAdviceGiven } from "./Components/OffPlatform/OffPlatfromAdviceGiven";
import { SubAccountTypeHelper } from "../../Dashboard/Components/Clients/Common/Helpers/SubAccountTypeHelper";
import { InstrumentSelection } from "../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelection";

interface IISTProps extends IProcessComponentProps {
    data: InstrumentSelections;
    type: ProcessType;
    product: SubAccountType;
    from?: SubAccountType;
    fromData?: any;
    bankAccounts: any[];
    hiercharyId: string;
    headAccountHierarchyId: string;
    companyCode: string;
    claccountId: string;
    withReRegistrationTransferIn: boolean;
    onBankChange?: (bankInfo) => void;
    onDistributionDividendOptions?: (options) => void;
    modelData: PensionContribution & {
        CashInstrument: Instrument;
        OwnerHierarchyId: string;
    };
    paymentAmount: Money; // all single payment + all regular payment + all cash transfer
    decisionMakerHierarchyId: string;
    accountAdviceType: AccountAdviceType;
    accountServiceProposition: ServiceProposition;
    onDecisionMakerChange?: (changes) => void;
    treasuredAssetsProductIds?: number[];
    onChangeTreasuredAssets?: (productId: number, value: boolean) => void;
}

interface IISTState {
    isShowAssetClass: boolean;
    notIncludeTableData: string[];
    isUnderTransfer?: boolean;
    clientHoldings: ProductInvestment;
    reuseType: reuseType;
    isDisplayAssetDisplayToggle: boolean;
    investmenPermission: PropositionInvestmentConfig[];
    userInfo: User;
    companyServicePropostion: ServiceProposition[];
    orderType: OrderType;
}

export class InvestmentSelectionTool extends ProcessComponent<IISTProps, IISTState> {
    constructor(props: IISTProps) {
        super(props);
        this.state = {
            userInfo: UserStore.getUserInfo(),
            reuseType: reuseType.no,
            isShowAssetClass: false,
            notIncludeTableData: [],
            investmenPermission: [],
            clientHoldings: null,
            isDisplayAssetDisplayToggle: true,
            companyServicePropostion: [],
            orderType: OrderType.Percentage,
        };
        this.subscribeToStore(SelectedInvestmentStore, () => this.onStoreChange());
    }

    componentDidMount() {
        super.componentDidMount();
        if (!this.props.data || this.props.data.Instruments.length == 0) {
            this.props.onChange({
                Instruments: [initInstrumentSelection(this.props.modelData.CashInstrument)],
            });
        } else if (
            !this.props.data.Instruments.find(
                (x) => x.Instrument.ProductId == this.props.modelData.CashInstrument.ProductId
            )
        ) {
            this.props.onChange({
                Instruments: [initInstrumentSelection(this.props.modelData.CashInstrument)].concat(
                    this.props.data.Instruments?.map((item) => ({allocation: null, ...item}))
                ),
            });
        }

        if ((this.props.type == ProcessType.NB || ProcessType.NBEC) && this.props.modelData.AccountServiceProposition) {
            InvestmentSelectionAction.getInvestmentPermission(this.props.modelData.AccountServiceProposition, (res) => {
                this.setState({ investmenPermission: res });
            });
        }

        if (this.props.companyCode) {
            CompanyWizardAction.getViewCompany(this.props.companyCode, (res) => {
                this.setState({ companyServicePropostion: res?.ServicePropositions });
            });
        }
    }

    private onStoreChange() {
        if (SelectedInvestmentStore.getActionType() == ActionType.Success) {
            const data = SelectedInvestmentStore.getData();
            if (!data) return;
            let _table = this.props.data.Instruments.concat();
            _table = _table.filter((item) =>
                data.every((ele) => ele.Instrument.ProductId !== item.Instrument.ProductId)
            );

            _table = _table.concat(data);
            this.props.onChange({ Instruments: _table });
        } else if (SelectedInvestmentStore.getActionType() == ActionType.Replace) {
            const data = SelectedInvestmentStore.getData();
            if (!data) return;
            let cash = data.filter((ele) => ele.Instrument.ProductId == this.props.modelData.CashInstrument.ProductId);
            if (cash.length == 0) {
                cash = [initInstrumentSelection(this.props.modelData.CashInstrument)];
            }
            this.props.onChange({
                Instruments: cash.concat(
                    data.filter((ele) => ele.Instrument.ProductId !== this.props.modelData.CashInstrument.ProductId)
                ),
            });
        }
    }

    private onReuse(v) {
        if (!v) {
            this.setState({ notIncludeTableData: [] });
            this.props.onChange({
                Instruments: [initInstrumentSelection(this.props.modelData.CashInstrument)],
            });
            return;
        }
        const { Instruments } = this.props.fromData;
        
        const ids = (Instruments as AllocationTableItem[]).map((ele) => ele.Instrument.ProductId);
        const query: InstrumentSearchQuery = {
            ProductWrapperTypes: [this.props.product],
            ProductIds: ids,
            CanBeBought: true,
            ResultsPerPage: ids.length,
            ServiceProposition: this.props.modelData.AccountServiceProposition,
        };
        InvestmentSelectionAction.searchInstruments(query, this.props.hiercharyId, (result: Instrument[]) => {
            const tableData = [];

            const notIncludeTableData = [];
            (Instruments as AllocationTableItem[]).forEach((ele) => {
                if (result.some((item) => item.ProductId == ele.Instrument.ProductId)) {
                    tableData.push(ele);
                } else if (ele.Instrument.Type !== ProductType.Cash) {
                    notIncludeTableData.push(ele.Instrument.ProductCode);
                }
            });
            if (tableData.every((item) => item.ProductId != this.props.modelData.CashInstrument?.ProductId)) {
                tableData.push(initInstrumentSelection(this.props.modelData.CashInstrument));
            }
            this.props.onChange({ Instruments: tableData });
            this.setState({ notIncludeTableData });
        });
    }

    private onUnderlyingToggle(isToggle, index, row: AllocationTableItem) {
        const _data: AllocationTableItem[] = this.props.data.Instruments.concat()?.map((item) => ({allocation: null, ...item}));
        if (isToggle) {
            const item = _data[index];
            _data[index].isToggle = isToggle;
            if (item.underlying) {
                this.props.onChange({ Instruments: _data });
            } else {
                InvestmentSelectionAction.getUnderlying(
                    row.Instrument.ProductId,
                    ModelPortfolioTabType.HubModel,
                    (data) => {
                        _data[index].underlying = data;
                        this.props.onChange({ Instruments: _data });
                    }
                );
            }
        } else {
            _data[index].isToggle = isToggle;
            this.props.onChange({ Instruments: _data });
        }
    }

    private investmentToAllocationTableItem(individual: InvestmentGroup[], model: InvestmentGroup[]) {
        if (individual.length == 0 && model.length == 0) {
            this.props.onChange({ Instruments: [] });
            return;
        }
        const individualInvestment: Investment[] = [];
        individual.forEach((group) => {
            group.Investments.forEach((investment) => {
                individualInvestment.push(investment);
            });
        });

        if (individualInvestment.length > 0) {
            let ids = individualInvestment.map((ele) => ele.ProductId);

            const query: InstrumentSearchQuery = {
                ProductWrapperTypes: [this.props.product],
                ProductIds: ids,
                CanBeBought: true,
                ResultsPerPage: ids.length,
                ServiceProposition: this.props.modelData.AccountServiceProposition,
            };

            InvestmentSelectionAction.searchInstruments(query, this.props.hiercharyId, (result: Instrument[]) => {
                this.props.onChange({ Instruments: reOrderISTInstruments(this.mapFundTableData(result)) });
            })
        } else {
            this.props.onChange({ Instruments: [] });
        }

        if ((model || []).length > 0) {
            this.modelInvestmentToAllocationTableItem(model);
        }
    }

    private modelInvestmentToAllocationTableItem(model: InvestmentGroup[]) {
        const modelInvestment: Investment[] = [];
        model.forEach((group) => {
            group.Investments.forEach((investment) => {
                modelInvestment.push(investment);
            });
        });
        const accountModelViewClient = new AccountModelViewClient();
        accountModelViewClient.get(this.props.hiercharyId, false).onSuccess((model: AccountModelView) => {
            this.getModelInstrumentDetails(model, modelInvestment);
        });
    }

    private getModelInstrumentDetails(model: AccountModelView, modelInvestment: Investment[]) {
        const modelInstrumentCodes = model.SubAccounts.filter((x) =>
            modelInvestment.some((y) => y.ProductId == x.ModelFundInstrumentId)
        ).map((x) => {
            return x.ModelInstrumentCode;
        });
        const _data = this.props.data.Instruments.concat();

        const instrumentsClient = new InstrumentsClient();
        instrumentsClient.get(modelInstrumentCodes).onSuccess((instruments) => {
            this.props.onChange({ Instruments: [..._data, ...this.mapModelTableData(instruments)] });
        });
    }

    private mapFundTableData(instruments: Instrument[]): AllocationTableItem[] {
        return instruments.map((ele) => {
            return this.mapTableData(ele, false);
        });
    }

    private mapModelTableData(instruments: Instrument[]) {
        return instruments.map((ele) => {
            return this.mapTableData(ele, true, ModelPortfolioTabType.HubModel);
        });
    }

    private mapTableData(
        instrument: Instrument,
        needToggle: boolean,
        modelPortfolioType?: ModelPortfolioTabType,
        allocation?,
        isTargetAllocation = false
    ): AllocationTableItem {
        return {
            Instrument: instrument,
            Single: initWeighting(allocation),
            ClientRegular: initWeighting(allocation),
            ThirdPartyRegular: initWeighting(allocation),
            EmployerRegular: initWeighting(allocation),
            Transfer: initWeighting(allocation),
            PostTransfer: initWeighting(allocation),
            needToggle: needToggle,
            isToggle: false,
            allocation: null,
            isTargetAllocation: isTargetAllocation,
            modelPortfolioType: modelPortfolioType,
        };
    }

    private getTargetAllocation(data: AssetClassInstrumentWeighting[]) {
        if (!data || data.length == 0) {
            this.props.onChange({ Instruments: [] });
            return;
        }
        const ids = data.map((ele) => ele.ProductId);
        const query: InstrumentSearchQuery = {
            ProductWrapperTypes: [this.props.product],
            ProductIds: ids,
            CanBeBought: true,
            ResultsPerPage: ids.length,
            ServiceProposition: this.props.modelData.AccountServiceProposition,
        };
        const tableData: AllocationTableItem[] = [];
        InvestmentSelectionAction.searchInstruments(query, this.props.hiercharyId, (result: Instrument[]) => {
            result.forEach((ele) => {
                let weight = data.find((investment) => investment.ProductId == ele.ProductId).Weighting;
                weight = Number(weight.toFixed(2));
                tableData.push(this.mapTableData(ele, false, null, weight, true));
            });
            this.props.onChange({ Instruments: reOrderISTInstruments(tableData) });
        });
    }

    private onReuseInvestment(v) {
        this.setState({ reuseType: v });
        if (v == reuseType.no) {
            this.props.onChange({
                Instruments: [initInstrumentSelection(this.props.modelData.CashInstrument)],
            });
            return;
        }
        const { clientHoldings } = this.state;
        if (!clientHoldings) {
            InvestmentsAction.getInvestments(
                [this.props.hiercharyId],
                JsonDateParser.toJsonDateNoOffset(new Date()),
                AssetClassType.Tier1,
                ViewType.Product,
                (data: ProductInvestment[]) => {
                    const _data = data[0];
                    v == reuseType.useCurrentAssets
                        ? this.investmentToAllocationTableItem(
                              _data.IndividualInvestments,
                              _data.ModelPortfolioInvestments
                          )
                        : this.getTargetAllocation(_data.InstrumentWeighting);
                    this.setState({ clientHoldings: _data });
                }
            );
        } else {
            v == reuseType.useCurrentAssets
                ? this.investmentToAllocationTableItem(
                      clientHoldings.IndividualInvestments,
                      clientHoldings.ModelPortfolioInvestments
                  )
                : this.getTargetAllocation(clientHoldings.InstrumentWeighting);
        }
    }

    private needDecisionMaker(data): boolean {
        if (this.props.type == ProcessType.Quote || this.props.type == ProcessType.WhatIf) return false;
        if (!data || !data.Instruments || data.Instruments.length == 0) return false;
        return (
            data.Instruments.some((ele) => [ProductType.Equity, ProductType.Bond].includes(ele.Instrument.Type)) ||
            data.Instruments.some(
                (ele) =>
                    ele.underlying &&
                    ele?.modelPortfolioType !== ModelPortfolioTabType.HubModel &&
                    ele.underlying.ModelPortfolioProducts &&
                    ele.underlying.ModelPortfolioProducts.some((ele) =>
                        [ProductType.Equity, ProductType.Bond].includes(ele.ProductType)
                    )
            )
        );
    }

    private onChangeSelection(data, id) {
        // update treasured state
        const _data = this.props.data.Instruments.concat();
        const index = _data.findIndex((ele) => ele.Instrument.ProductId == id);
        if (data === -1) {
            if (this.props.onChangeTreasuredAssets && index > -1) {
                this.props.onChangeTreasuredAssets(_data?.[index]?.Instrument?.ProductId, false);
            }
            _data.splice(index, 1);
        } else {
            for (const key in data) {
                _data[index][key] = data[key];
            }
        }
        this.props.onChange({ Instruments: _data });
    }

    private onOffPlatformClick = (tabType) => {
        const isDisplayAssetDisplayToggle = tabType === investmentType.OffPlatform;
        this.setState({ isDisplayAssetDisplayToggle: !isDisplayAssetDisplayToggle });
    };

    render() {
        const {
            type,
            product,
            from,
            data,
            onChange,
            withReRegistrationTransferIn,
            treasuredAssetsProductIds,
            onChangeTreasuredAssets,
        } = this.props;
        if (!data) return null;
        const needDecisionMake = this.needDecisionMaker(data);

        let restrictedMessage = "An account with suspended or restricted activities cannot setup Investment selection";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
        }

        return (
            <div className="ist-wrap">
                {RestrictionStore.buyDisabled() && <Alert alertType={AlertType.Error} message={restrictedMessage} />}
                {!withReRegistrationTransferIn && useSameInvestmentAsPerProductShowCondition(type, product) && (
                    <Reuse
                        data={from}
                        isReview={RestrictionStore.buyDisabled()}
                        onRef={(ref) => this.appendChild(ref)}
                        onChange={(v) => this.onReuse(v)}
                    />
                )}
                {!withReRegistrationTransferIn && reuseShowCondition(type) && (
                    <ReuseInvesment
                        isReview={RestrictionStore.buyDisabled()}
                        onReuseInvesment={(v) => {
                            this.onReuseInvestment(v);
                        }}
                        data={data}
                        onChange={onChange}
                        onRef={(ref) => this.appendChild(ref)}
                    />
                )}

                <SearchTabs
                    hiercharyId={this.props.hiercharyId}
                    product={product}
                    data={data.Instruments}
                    isUnderTransfer={withReRegistrationTransferIn}
                    onTabClick={this.onOffPlatformClick}
                    disabled={RestrictionStore.buyDisabled()}
                    investmentPermission={this.state.investmenPermission}
                    accountServiceProposition={this.props.accountServiceProposition}
                    canBeBought={true}
                    canBeSold={false}
                    companyServiceProposition={this.state.companyServicePropostion}
                />

                {this.state.isDisplayAssetDisplayToggle && (
                    <div className="pb-18 pt-24">
                        <div className="flex-space">
                            <div className="flex-line">
                                <span aria-hidden="true" className="mr-8">
                                    Asset class display:{" "}
                                </span>
                                <ToggleButtonTwoOptions
                                    optionOne="Off"
                                    optionTwo="On"
                                    value={this.state.isShowAssetClass}
                                    onChange={(v) => this.setState({ isShowAssetClass: v })}
                                    label=""
                                />
                            </div>
                            {/* <div className="ist-payment-amount">
                                    <div className="title">Payment amount:</div>
                                    <div className="text-right">
                                        {MoneyDisplayHelper.getMoneyFormat({
                                            Amount: paymentAmount.Amount,
                                            Currency: paymentAmount.Currency,
                                        })}
                                    </div>
                                </div> */}
                        </div>
                    </div>
                )}
                <h3 className="mb-0">Allocation</h3>

                <AllocationTable
                    onRef={(ref) => this.appendChild(ref)}
                    cssWrapper="table-expandable is-allocation-table"
                    accountServiceProposition={this.props.accountServiceProposition}
                    product={this.props.product}
                    type={this.props.type}
                    orderType={this.state.orderType}
                    modelData={this.props.modelData}
                    data={reOrderISTInstruments(this.props.data.Instruments)}
                    showErrorMsgPopUp={(msg) => this.props.showErrorMsgPopUp(msg)}
                    onChange={(data, productId) => this.onChangeSelection(data, productId)}
                    onToggle={(isToggle, index, rowData) => this.onUnderlyingToggle(isToggle, index, rowData)}
                    isAssetClass={this.state.isShowAssetClass}
                    treasuredAssetsProductIds={treasuredAssetsProductIds}
                    onChangeTreasuredAssets={(productId, value) => onChangeTreasuredAssets(productId, value)}
                />

                {/* {allocationInfoTextShowConditon.some((ele) => ele == this.props.type) &&
                            SubAccountTypeHelper.isPension(this.props.product) && (
                                <p>
                                    Please note the actual payment amounts are shown gross and the value invested will
                                    be reduced where initial adviser charges are being taken
                                </p>
                            )} */}
                {this.state.notIncludeTableData.length > 0 && (
                    <p>
                        The following Instrument(s): {this.state.notIncludeTableData.toString()} cannot be brought
                        forward for this product. Please select a replacement or increase outstanding allocation amount
                        on remaining investments.
                    </p>
                )}
                {!withReRegistrationTransferIn && manageIncomeShowCondition(type, product) && (
                    <ManageIncome
                        clAccountId={this.props.claccountId}
                        data={this.props.modelData.DistributionDividendOptions}
                        onChange={(changes) => this.props.onDistributionDividendOptions(changes)}
                        onRef={(ref) => this.appendChild(ref)}
                        type={type}
                        product={product}
                    />
                )}
                {!withReRegistrationTransferIn && distributionOptionsShowCondition(type, product) && (
                    <DistributionOption
                        product={this.props.product}
                        ownerId={this.props.modelData.OwnerHierarchyId}
                        clAccountId={this.props.claccountId}
                        data={this.props.modelData.DistributionDividendOptions}
                        onChange={(changes) => this.props.onDistributionDividendOptions(changes)}
                        onRef={(ref) => this.appendChild(ref)}
                        type={type}
                        onBankChange={(bank) => this.props.onBankChange(bank)}
                        bankAccounts={this.props.bankAccounts}
                        showErrorMsgPopUp={(msg, showNow) => this.props.showErrorMsgPopUp(msg, showNow)}
                    />
                )}
                {needDecisionMake && !withReRegistrationTransferIn && (
                    <DecisionMaker
                        clAccountId={this.props.claccountId}
                        headAccountHierarchyId={this.props.headAccountHierarchyId}
                        companyCode={this.props.companyCode}
                        data={this.props.modelData}
                        onChange={(changes) => this.props.onDecisionMakerChange(changes)}
                        onRef={(ref) => this.appendChild(ref)}
                        accountAdviceType={this.props.accountAdviceType}
                    />
                )}
                <OffPlatformAdviceGiven
                    data={data}
                    type={type}
                    product={product}
                    isAdviceGiven={this.props.data?.AdviceGivenForOffPlatform}
                    onChange={(v) => this.props.onChange({ AdviceGivenForOffPlatform: v })}
                />
            </div>
        );
    }
}
